import { createBrowserRouter, Navigate, redirect } from 'react-router-dom'

import { AppShell } from '@/components/layout/app-shell'
import { api } from '@/lib/api-client'
import { AuthLayout } from '@/routes/_auth/auth-layout'

export async function privateLoader() {
  try {
    const { data } = await api.get<{ user?: unknown } | null>('/api/auth/get-session')
    if (!data?.user) {
      const next = encodeURIComponent(window.location.pathname + window.location.search)
      // React Router loaders sinalizam redirect via `throw new Response(...)` — pattern oficial.
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect(`/sign-in?next=${next}`)
    }
    return data.user
  } catch (err) {
    if (err instanceof Response) throw err
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect('/sign-in')
  }
}

export const router = createBrowserRouter([
  {
    path: '/',
    children: [{ index: true, element: <Navigate to="/sign-in" replace /> }],
  },

  {
    element: <AuthLayout />,
    children: [
      {
        path: '/sign-in',
        lazy: () =>
          import('@/features/auth/pages/sign-in-page').then((m) => ({ Component: m.SignInPage })),
      },
    ],
  },

  {
    path: '/app',
    element: <AppShell />,
    loader: privateLoader,
    children: [
      // `/app` abre o Bloco default (comercial); cada Bloco tem sua própria rota.
      { index: true, element: <Navigate to="/app/comercial" replace /> },
      {
        path: 'financeiro',
        lazy: () =>
          import('@/features/financeiro/pages/painel-financeiro-page').then((m) => ({
            Component: m.PainelFinanceiroPage,
          })),
      },
      {
        path: 'comercial',
        lazy: () =>
          import('@/features/relatorio/pages/painel-page').then((m) => ({
            Component: m.PainelPage,
          })),
      },
      {
        path: 'operacao',
        lazy: () =>
          import('@/features/operacao/pages/painel-operacao-page').then((m) => ({
            Component: m.PainelOperacaoPage,
          })),
      },
      {
        path: 'comercial/metas',
        lazy: () =>
          import('@/features/metas/pages/metas-page').then((m) => ({ Component: m.MetasPage })),
      },
      {
        path: 'comercial/pre-vendas',
        lazy: () =>
          import('@/features/pre-vendas/pages/pre-vendas-page').then((m) => ({
            Component: m.PreVendasPage,
          })),
      },
      {
        path: 'eventos/proximos-eventos',
        lazy: () =>
          import('@/features/sympla/pages/sympla-page').then((m) => ({
            Component: m.SymplaPage,
          })),
      },
      // Compat com o link antigo do BI do Sympla.
      {
        path: 'eventos/sympla',
        element: <Navigate to="/app/eventos/proximos-eventos" replace />,
      },
      // Compat com links antigos de quando Metas vivia fora do Bloco comercial.
      { path: 'metas', element: <Navigate to="/app/comercial/metas" replace /> },
    ],
  },

  { path: '*', element: <Navigate to="/" replace /> },
])
